// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1TeamsPatchSchema = z.object({
  team: z.object({
    name: z.optional(z.coerce.string().min(1).max(255).describe("Name of the team")),
    color: z.optional(z.coerce.string().min(3).max(6).regex(new RegExp("^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$")).describe("Team display color (hex code)")),
    emoji: z.optional(z.coerce.string().describe("Team emoji")),
    users: z.optional(z.array(z.unknown()).describe("Array of user objects with user_id, lead, and hide_hours properties")),
  }),
});
